var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loginBG",style:('height:' + this.$store.state.maxH + 'px')},[_c('div',{staticClass:"loginBox"},[_c('login_c')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }